



function App () {
	return (
		<div className="App">
			<main className="flex min-h-screen bg-red-500">
				<div className="text-white text-center m-auto">
					<h2 className="text-4xl py-6">React Starter</h2>
					<a href="https://github.com/iaseth/react-starter" target="_blank" rel="noreferrer" className="px-4 py-3 text-sm bg-red-600 duration-300 hover:bg-red-700">GitHub</a>
				</div>
			</main>
		</div>
	);
}

export default App;
